export const EnvType = {
    dev: 'DEV',
    uat: 'UAT',
    pro: 'PRO'
}

export const GlobalConfig = {
    envType: EnvType.dev
}

export const isDebug = (GlobalConfig.envType !== EnvType.pro);
